export const COGNITO = {
  USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  APP_CLIENT_ID: import.meta.env.VITE_COGNITO_APP_CLIENT_ID as string
};

export const SERVER_URL = import.meta.env.VITE_SERVER_ENDPOINT as string;
